<template>
  <div class="lidaCard" style="padding: 4px">
    <modal-betting-list></modal-betting-list>
    <liveshow-game-tabs :topbardata="topbardata"></liveshow-game-tabs>
    <modal-modify-the-odds @refresh="refreshChildren"></modal-modify-the-odds>
    <Row class="px-1 py-2">
      <Col :span="$route.meta.rightTable ? 23 : 24" style="line-height: 1.5rem;">
        <Row>
          <nav-setting-tool :topbardata="topbardata" @refresh="refreshChildren"></nav-setting-tool>
        </Row>
      </Col>
      <Spin fix v-show="getliveshow.setloading" style="color:black">
        <Icon type="ios-loading" size="40" class="demo-spin-icon-load"></Icon>
        <h2 class="mt-2">处理中请稍后</h2>
      </Spin>
    </Row>
    <Row>
      <Col>
        <router-view @refresh="refreshChildren" ref="get_part_fun"></router-view>
      </Col>
    </Row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import checkpath from "./mixins/checkPath.js";

export default {
  name: "liveshow",
  mixins: [checkpath],
  components: {
    liveshowGameTabs: () =>
      import(/* webpackChunkName: "liveshow-liveshowGameTabs" */ "./components/liveshowGameTabs"),
    NavSettingTool: () =>
      import(/* webpackChunkName: "liveshow-NavSettingTool" */ "./components/NavSettingTool"),
    ModalBettingList: () =>
      import(/* webpackChunkName: "tool-ModalBettingList" */ "@/components/tool/ModalBettingList.vue"),
    ButtonOpeningStatus: () =>
      import(/* webpackChunkName: "liveshow-components" */ "./components/ButtonOpeningStatus.vue"),
    ModalModifyTheOdds: () =>
      import(/* webpackChunkName: "liveshow-components" */ "./components/ModalModifyTheOdds.vue"),
  },
  data () {
    return {
      topbardata: {},
      closeaarea: [
        {
          value: "10",
          label: "10"
        },
        {
          value: "30",
          label: "30"
        },
        {
          value: "60",
          label: "60"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getliveshow", "getmember", "getpermission", "getgameid"]),
    colSpan () {
      if ($route.meta.rightTable) {
        return 18
      } else {
        return 24
      }
    },
    openCloseGameData () {
      const array1 = this.selectData['1']
      const array2 = this.selectData[this.$route.meta.page]
      const array = array1.concat(array2)
      if (this.$route.meta.page == 9) { // 高頻六沒有 肖數玩法
        return array.slice(0, 13)
      }
      return this.$route.meta.page == '1' ? array1 : array
    },
    selectData () {
      return {
        '1': [
          { value: 1, game: this.$t("lsib.TeMa") },
          { value: 99, game: this.$t('message.notSpecialNum') }
        ],
        '2': [
          { value: 2, game: this.$t('lsib.JengMa') },
          { value: 34, game: this.$t('lsib.LMZDanShuang') },
          { value: 35, game: this.$t('lsib.LMZDaShiau') }
        ],
        '3': [
          { value: 3, game: this.$t('lsib.Jeng1Te') }
        ],
        '4': [
          { value: 4, game: this.$t('lsib.Jeng2Te') }
        ],
        '5': [
          { value: 5, game: this.$t('lsib.Jeng3Te') }
        ],
        '6': [
          { value: 6, game: this.$t('lsib.Jeng4Te') }
        ],
        '7': [
          { value: 7, game: this.$t('lsib.Jeng5Te') }
        ],
        '8': [
          { value: 8, game: this.$t('lsib.Jeng6Te') }
        ],
        '9': [
          { value: 20, game: this.$t('lsib.ShengShiau') + this.$t('lsib.Jung') },
          { value: 21, game: this.$t('lsib.ShengShiau') + this.$t('lsib.BuJung') },
          { value: 22, game: this.$t('lsib.WeiShu') + this.$t('lsib.Jung') },
          { value: 25, game: this.$t('lsib.TeMaLiouShiau') + this.$t('lsib.Jung') },
          { value: 26, game: this.$t('lsib.TeMaLiouShiau') + this.$t('lsib.BuJung') },
          { value: 71, game: this.$t('lsib.Shiau2') },
          { value: 72, game: this.$t('lsib.Shiau3') },
          { value: 73, game: this.$t('lsib.Shiau4') },
          { value: 74, game: this.$t('lsib.Shiau5') },
          { value: 75, game: this.$t('lsib.Shiau6') },
          { value: 76, game: this.$t('lsib.Shiau7') },
          { value: 77, game: "1肖数" },
          { value: 78, game: "2肖数" },
          { value: 79, game: "3肖数" },
          { value: 80, game: "4肖数" },
          { value: 81, game: "5肖数" },
        ],
        '10': [
          { value: 9, game: this.$t('lsib.ErChiuanJung') },
          { value: 10, game: this.$t('lsib.ErJungTe') },
          { value: 12, game: this.$t('lsib.ErTeChuan') },
          { value: 13, game: this.$t('lsib.SanChiuanJung') },
          { value: 14, game: this.$t('lsib.SanJungEr') }
        ],
        '11': [
          { value: 40, game: this.$t('lsib.ErShiauLian') + this.$t('lsib.Jung') },
          { value: 41, game: this.$t('lsib.ErShiauLian') + this.$t('lsib.BuJung') },
          { value: 42, game: this.$t('lsib.SanShiauLian') + this.$t('lsib.Jung') },
          { value: 43, game: this.$t('lsib.SanShiauLian') + this.$t('lsib.BuJung') },
          { value: 44, game: this.$t('lsib.SzShiauLian') + this.$t('lsib.Jung') },
          { value: 45, game: this.$t('lsib.SzShiauLian') + this.$t('lsib.BuJung') },
          { value: 46, game: this.$t('lsib.WuShianLian') + this.$t('lsib.Jung') },
          { value: 47, game: this.$t('lsib.WuShianLian') + this.$t('lsib.BuJung') }
        ],
        '12': [
          { value: 48, game: this.$t('lsib.ErWeiLian') + this.$t('lsib.Jung') },
          { value: 49, game: this.$t('lsib.ErWeiLian') + this.$t('lsib.BuJung') },
          { value: 50, game: this.$t('lsib.SanWeiLian') + this.$t('lsib.Jung') },
          { value: 51, game: this.$t('lsib.SanWeiLian') + this.$t('lsib.BuJung') },
          { value: 52, game: this.$t('lsib.SzWeiLian') + this.$t('lsib.Jung') },
          { value: 53, game: this.$t('lsib.SzWeiLian') + this.$t('lsib.BuJung') }
        ],
        '13': [
          { value: 54, game: this.$t('lsib.WuBuJung') },
          { value: 55, game: this.$t('lsib.LiouBuJung') },
          { value: 56, game: this.$t('lsib.ChiBuJung') },
          { value: 57, game: this.$t('lsib.BaBuJung') },
          { value: 58, game: this.$t('lsib.JiouBuJung') },
          { value: 59, game: this.$t('lsib.ShrBuJung') }
        ],
        '14': [
          { value: 60, game: this.$t('lsib.WuJungYi') },
          { value: 61, game: this.$t('lsib.LiouJungYi') },
          { value: 62, game: this.$t('lsib.ChiJungYi') },
          { value: 63, game: this.$t('lsib.BaJungYi') },
          { value: 64, game: this.$t('lsib.JiouJungYi') },
          { value: 65, game: this.$t('lsib.ShrJungYi') }
        ],
        '15': [
          { value: 66, game: this.$t('lsib.YiLiRenJung') },
          { value: 67, game: this.$t('lsib.ErLiRenJung') },
          { value: 68, game: this.$t('lsib.SanLiRenJung') },
          { value: 69, game: this.$t('lsib.SzLiRenJung') },
          { value: 70, game: this.$t('lsib.WuLiRenJung') }
        ],
        '16': [
          { value: 16, game: this.$t('lsib.GuoGuanDan') },
          { value: 17, game: this.$t('lsib.GuoGuanShuang') },
          { value: 18, game: this.$t('lsib.GuoGuanDa') },
          { value: 19, game: this.$t('lsib.GuoGuanShiau') },
          { value: 23, game: this.$t('lsib.BanPoDanShuang') },
          { value: 24, game: this.$t('lsib.BanPoDaShiau') },
          { value: 27, game: this.$t('lsib.LiangMianDan') },
          { value: 28, game: this.$t('lsib.LiangMianShuang') },
          { value: 29, game: this.$t('lsib.LiangMianDa') },
          { value: 30, game: this.$t('lsib.LiangMianShiau') },
          { value: 31, game: this.$t('lsib.LiangMianHeDan') },
          { value: 32, game: this.$t('lsib.LiangMianHeShuang') },
          { value: 33, game: this.$t('lsib.LiangMianWeiDaShiau') },
          { value: 36, game: this.$t('lsib.SePoHung') },
          { value: 37, game: this.$t('lsib.SePoLan') },
          { value: 38, game: this.$t('lsib.SePoLiu') },
          { value: 39, game: this.$t('lsib.TeMaShengShiau') }
        ]
      }
    },
  },
  watch: {
    $route: {
      handler (newValue, oldValue) {
        if (this.routerSplit(newValue.name) != this.routerSplit(oldValue.name)) {
          this.chg_liveshow_state({ chgbaco: 0 });
        }
        this.refreshApi();
      }
    },
    "getliveshow.siteSelect" (val) {
      if (this.liveshowPath) return
      this.refreshApi();
    },
  },
  created () {
    this.NavDatalimit();
  },
  mounted () {
    this.$Eventhub.$on("liveshow-refresh", () => this.refreshApi());
  },
  destroyed () {
    this.$Eventhub.$off("liveshow-refresh");
  },
  methods: {
    ...mapActions(["chg_liveshow_state", "setTopBarData"]),
    refreshApi () {
      this.NavDatalimit();
      this.refreshChildren();
    },
    // 现场监督上方数字
    async NavDatalimit () {
      try {
        // this.topbardata = {}
        if (this.getliveshow.siteSelect == '') return
        let result = this.liveshowPath
          ? await this.$axios.liveshow.upNavData(this.getgameid)
          : await this.$axios.liveshow.AllupNavData(this.getgameid, this.getliveshow.siteSelect);
        if ('status' in result && result.status === 0) return
        if (result && (this.liveshowPath || this.liveshowAllPath)) {
          this.topbardata = result[0];
          this.setTopBarData({ topbardata: this.topbardata, RouteModule: this.$route })
        }
      } catch (error) {
        console.log(error);
        this.$Message.error("網路異常:(S3001)");
      }
    },
    // 重新拉取子路径玩法倍率
    refreshChildren () {
      this.$refs.get_part_fun.readyaxiso();
      this.$Eventhub.$emit("righTable-refesh");
    }

  }
};
</script>

<style lang="scss">
.demo-spin-icon-load {
  animation: ani-demo-spin 0.5s linear infinite;
}
.ranking-top {
  th,
  td {
    background: rgb(255, 245, 152) !important;
  }
}
</style>